export const paramsOfTextureAction = (objId, procode) => {
  // console.log(paramsCode);
  return async (dispatch) => {
    const paramsCode = objId + "_" + procode;
    await dispatch({ type: "PARAMS_TEXTURE", payload: paramsCode });
  };
};
export const paramsOfTextureViaQueryAction = (params) => {
  return async (dispatch) => {
    await dispatch({ type: "PARAMS_TEXTURE", payload: params });
  };
};

export const locationOfCarpeteAction = () => {
  return async (dispatch) => {
    await dispatch({ type: "RESET_POSITION" });
  };
};

export const secondCarpeteAction = () => {
  return async (dispatch) => {
    await dispatch({ type: "SECOND_CARPET" });
  };
};

export const sizeChangeAction = (size) => {
  return async (dispatch) => {
    const carpet_size = size;
    await dispatch({ type: "SIZE_CHANGE", payload: carpet_size });
  };
};
